'use-strict';

/* global TweenMax, TimelineMax, Sine, Back, Power3 */

import { $ } from '../../helper/utils';

const searchWrapper = $('.search-wrapper');
const showsearch = $('.nav-search > i');
const closesearch = $('.nav-search > .close-search');
const searchBackdrop = $('.search-backdrop');
const searchTarget = $('.search-label > i');
const searchInput = $('#search > input');
const searchBorder = $('.search-border');

export const searchTween = () => {
    const first = showsearch.getBoundingClientRect();
    const last = searchTarget.getBoundingClientRect();
    const invertx = first.left - last.left;
    const inverty = first.top - last.top;
    const invertsx = first.width / last.width;
    const invertsy = first.height / last.height;

    TweenMax.set(searchTarget, { opacity: 0, x: invertx, y: inverty, scaleX: invertsx, scaleY: invertsy, transformOrigin: '0 0' });

    const tl = new TimelineMax({
        paused: true,
        id: 'search',
        onComplete() {
            searchInput.focus();
        },
        onReverseComplete() {
            TweenMax.set(searchTarget, { clearProps: 'all' });
        }
    });

    return tl
        .set(searchWrapper, { autoAlpha: 1, pointerEvents: 'auto' })
        .fromTo(searchBackdrop, .5, { yPercent: -100 }, { yPercent: 0, ease: Sine.easeOut })
        .set(showsearch, { opacity: 0, pointerEvents: 'none' }, '-=.4')
        .to(closesearch, .15, { opacity: 1, pointerEvents: 'auto', ease: Sine.easeOut })
        .fromTo(searchTarget, .75, { opacity: 1 }, {
            x: 0,
            y: 0,
            scaleX: 1,
            scaleY: 1,
            opacity: .7,
            rotation: -360,
            immediateRender: false
        }, '-=.4')
        .to(searchBorder, .7, {
            scaleX: 1,
            ease: Back.easeOut.config(1)
        })
        .to(searchInput, .3, {
            opacity: 1,
            ease: Power3.easeOut
        });
};